export default __webpack_public_path__ + "static/media/spotify_icon.cd66b8f6.png";